import { makeStyles } from '@material-ui/core';

export const useCodeStyles = makeStyles(() => ({
  container: {
    border: '1px dashed black',
    borderRadius: 10,
    padding: 20,
  },
  title: {
    fontSize: 16,
  },
  number: {
    fontSize: 22,
    fontWeight: 700,
  },
}));

export const useDetailStyles = makeStyles(() => ({
  title: {
    fontSize: 16,
    fontWeight: 600,
  },
  container: {
    padding: 12,
  },
}));
